// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_48-7";
export var adjustableWidthBorderHeld = "_48-8";
export var arrow = "_48-3";
export var arrowButton = "_48-4";
export var headerCell = "_48-0";
export var help = "_48-2";
export var icon = "_48-1";
export var iconWrapper = "_48-6";
export var noBorder = "_48-b";
export var nonAdjustableWidthBorder = "_48-9";
export var nonAdjustableWidthBorderHeld = "_48-a";
export var textButton = "_48-5";